import React from "react"

import style from "./EmptyVenuesAlert.module"

export default function EmptyVenuesAlert() {
  return (
    <div className="col-xs-10 col-xs-offset-1">
      <div className="no-delivery-box">
        <div className={style.container}>
          <h1>😔</h1>
          <h2 className="featurette-heading">
            {I18n.t("react.venues.no_result.empty_venues")}
          </h2>
        </div>
      </div>
    </div>
  )
}
